$(document).ready(function () {
    $('.open-search').click(function () {
        vm.isOpen = !vm.isOpen;
        vm.topic = "";
        //if (vm.isOpen) {
        //    setTimeout(function () {
        //        $('.search__input').focus();
        //    }, 1000);
        //}
        //else {
        //    $('.search__input').blur();
        //}
    });
    $(document).keyup(function (e) {
        if (e.keyCode == 27) {
            vm.isOpen = false;
        }
    });
});

$(window).scroll(function () {
    if ($(this).scrollTop() > 150) {
        vm.fixed = true;
    } else {
        vm.fixed = false;
    }
});

Vue.prototype.$first = function (item, list) {
    return item === list[0]
};
var vm = new Vue({
    el: "#vue-search",
    data: {
        isOpen: false,
        topic: "",
        autocompleteResults: {},
        fixed: false
    },
    updated: function () {
        if (this.isOpen) {
            setTimeout(function () {
                $('.search__input').focus();
            }, 1000);
        } else {
            $('.search__input').blur();
        }
        $('.post-ac-results').textfill(false, false);
        epicaAddEventClick('#vue-search');
    },
    methods: {
        autocomplete: _.debounce(function () {
            if (this.topic) {
                this.$http.get('/api/ac/' + this.topic).then(function (response) {
                    this.autocompleteResults = response.body;
                }, function (response) {

                });
            } else {
                this.autocompleteResults = {};
            }
        }, 200)
    }
});


var vm2 = new Vue({
    el: "#vue-mobile-search",
    data: {
        isOpen: false,
        topic: "",
        autocompleteResults: {}
    },
    updated: function () {
        epicaAddEventClick('#vue-mobile-search');
        $('.post-ac-mobile-results').textfill(false, true);
    },
    methods: {
        autocomplete: _.debounce(function () {
            if (this.topic) {
                this.$http.get('/api/ac/' + this.topic).then(function (response) {
                    this.autocompleteResults = response.body;
                }, function (response) {});
            } else {
                this.autocompleteResults = {};
            }
        }, 200)
    }
});